import { Inject, Injectable, Provider, inject } from '@angular/core';
import { ApiService } from './api.service';
import { Subject } from 'rxjs';
import { SnackbarService } from './snackbar-psa.service';  // Use SnackbarService instead of AppSnackbarComponent

@Injectable({
  providedIn: 'root'
})
export class CrudService<T> {

  constructor(
    @Inject('endpoint') protected endpoint: string,
    @Inject(ApiService) protected readonly api: ApiService,
    @Inject(SnackbarService) protected readonly snackbar: SnackbarService, // Inject SnackbarService here
  ) { }

  read(id: number | string) {
    let model: Subject<T> = new Subject<T>();
    this.api.get<T>(`${this.endpoint}/${id}`).subscribe((value) => {
      model.next(value)
    });
    return model.asObservable();
  }

  readAll() {
    let model: Subject<T> = new Subject<T>();
    this.api.get<T>(`${this.endpoint}`).subscribe((value) => {
      model.next(value)
    });
    return model.asObservable();
  }

  save(model: any, id?: number | string) {
    let saved: Subject<T> = new Subject<T>();
    let url = this.endpoint;
    if (id) {
      url += `/${id}`;
      this.api.put<T>(url, model).subscribe({
        next: value => saved.next(value),
        complete: () => this.snackbar.open('Dati salvati con successo!', 'close')
      });
    } else {
      this.api.post<T>(url, model).subscribe({
        next: value => saved.next(value),
        complete: () => {
          this.snackbar.open('Dati salvati con successo!', 'close')
        }
      });
    }
    return saved.asObservable();
  }

  delete(id: number | string, body ?: any | null) {
    let deleted: Subject<any> = new Subject<any>();
    this.api.delete(`${this.endpoint}/${id}`, body).subscribe({
      next: (value) => {
        deleted.next(value);
      },
      complete: () => this.snackbar.open('Dati eliminati con successo!', 'close')
    })
    
    return deleted;
  }

}

export function provideCrudService<T>(
  endpoint: string,
  snackbar: SnackbarService,  // Inject SnackbarService in factory function
): Provider[] {
  return [
    {
      provide: createTokenCrudServiceInstance(endpoint),
      useFactory: () => new CrudService<T>(
        endpoint,
        inject(ApiService),
        snackbar
      ),
    }
  ]
}

export function createTokenCrudServiceInstance(endpoint: string) {
  return `${endpoint}-crud-service`;
}
